import { Box, Tab, Tabs } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';

import { SettingsSidebarItem } from 'shared/components/navigation';

interface Props {
  listData: SettingsSidebarItem[];
}

export function SettingsMobileNavbarList(props: Props) {
  const { pathname } = useLocation();
  const { push: navigate } = useHistory();

  const handleChangeRoute = (_event: unknown, route: string) => {
    navigate(route);
  };

  return (
    <Box display="flex">
      <Tabs value={pathname} variant="scrollable" scrollButtons="auto" onChange={handleChangeRoute}>
        {props.listData.map(item => (
          <Tab
            key={item.route}
            icon={<Box>{item.icon}</Box>}
            value={item.route}
            label={item.title}
            wrapped
          />
        ))}
      </Tabs>
    </Box>
  );
}
